import { render } from "./Newsfeed.vue?vue&type=template&id=9efa1256&scoped=true"
import script from "./Newsfeed.vue?vue&type=script&lang=js"
export * from "./Newsfeed.vue?vue&type=script&lang=js"

import "./Newsfeed.vue?vue&type=style&index=0&id=9efa1256&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9efa1256"]])

export default __exports__